import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";

export function C10({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.TFLW001.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the flow rates between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plans. These differences are highlighted in the following table.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row}>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell rowSpan={3} style={{verticalAlign: 'bottom', textAlign: 'left'}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center'}} colSpan={(row?.base_profile_names?.length + row?.cmp_profile_names?.length)}>Flow Rate (cfs)</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell colSpan={row?.base_profile_names?.length} style={{width: row?.base_profile_names?.length*70}}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                            <ResultHeaderCell colSpan={row?.cmp_profile_names?.length} style={{width: row?.cmp_profile_names?.length*70}}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            {
                                row?.base_profile_names?.map(x => (
                                    <ResultHeaderCell style={{width: 100, textAlign: 'left'}}>{x}</ResultHeaderCell>
                                ))
                            }
                            {
                                row?.cmp_profile_names?.map(x => (
                                    <ResultHeaderCell style={{width: 100, textAlign: 'left'}}>{x}</ResultHeaderCell>
                                ))
                            }
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row.data.map(x => (
                                    <ResultRow>
                                        <ResultBodyCell style={{width: 125}}><ComparisonCSName csName={x.cross_section} /></ResultBodyCell>
                                        {
                                            x.sel_profile_data.map(x => (
                                                <ResultBodyCell>{x.value}</ResultBodyCell>
                                            ))
                                        }
                                        {
                                            x.cmp_profile_data.map((y, idx) => (
                                                <ResultBodyCell>{ResultCellHighlight(x.sel_profile_data[y.cmp_index]?.value, y.value)}</ResultBodyCell>
                                            ))
                                        }
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.TFLW002.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the Boundary Conditions between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plans. These differences are highlighted in the following table.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row}>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell></ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center'}} colSpan={2}>Boundary Condition</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left'}}>Profile</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'left'}}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'left'}}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            row.data.map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{width: 125}}>{r.profile_name}</ResultBodyCell>
                                        <ResultBodyCell style={{paddingRight: 16}}>{r.base.dn_text} {(r.base.dn_value && ` = ${r.base.dn_value}`) || ''}</ResultBodyCell>
                                        <ResultBodyCell style={{paddingRight: 16}}>
                                            {ResultCellHighlight(r.base.dn_text, r.cmp.dn_text)}
                                            <span>
                                                {r.cmp.dn_value && ' = '}
                                                {r.cmp.dn_value && ResultCellHighlight(r.base.dn_value, r.cmp.dn_value)}
                                            </span>
                                        </ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.FLW003.error_id: {
            return (
                <>
                    <ResultText>
                        The following flow change location is added to the flow table:
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => ({csName: x.cross_section, csNameVal: x.cross_section}))} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.FLW004.error_id: {
            return (
                <>
                    <ResultText>
                        The following flow change location is removed from the flow table:
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => ({csName: x.cross_section, csNameVal: x.cross_section}))} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.FLW005.error_id: {
            return (
                <>
                    <ResultText>
                        The following flow profile is removed from the flow table.
                    </ResultText>
                    <ResultText>
                        {row.data.map(x => x.profile_name).join(', ')}
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.FLW006.error_id: {
            return (
                <>
                    <ResultText>
                        The following flow profile is added to the flow table.
                    </ResultText>
                    <ResultText>
                        {row.data.map(x => x.profile_name).join(', ')}
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.FLW000.error_id: {
            return `Flow Data could not be compared since the flow profiles are not labeled!`
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}